import React from "react";
import AccountMenu from "../AccountMenu";
import { Box, Typography } from "@mui/material";
import { SearchField } from "../../Components/Search";
import CrudJogos from "./components/EditableJogos";
import { SkeletonGrid } from "../../Components/Skeleton";
import { useDispatch, useSelector } from "react-redux";
import GamesOperations from "../../InfraStructure/Games/GamesOperations";
import Toast from "../../Common/Helpers/Toast";
import Failure from "../../Components/Failure";
import { ResponseProps } from "./components/types";

export default function Jogos() {
  const [open, setOpen] = React.useState<boolean>(false);
  const [message, setMessage] = React.useState<string>('');
  const [filteredData, setFilteredData] = React.useState<any[]>();

  const dispatch = useDispatch();
  const { IsLoading, HasError, Data } = useSelector(
    (state: any) => state.games
  );

  const openToast = (message: string) => {
    setMessage(message);
    setOpen(true);
  }

  const getGames = async () => {
    try {
      await dispatch<any>(GamesOperations.getGames());
    } catch (error: string | unknown) {
      console.log('Erro buscando jogos: ', error);
      openToast('Erro na rede. Tente novamente...');
    }
  }

  React.useEffect(() => {
    getGames();
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    if (Data) {
      setFilteredData(Data);
    }
  }, [Data]);

  const handleSave = async (data: any): Promise<ResponseProps> => {
    const formData = new FormData();
    formData.append('nome', data.nome);
    formData.append('nivel_id', data.nivel_id);
    formData.append('url', data.url);
    formData.append('imagem', data.imagem);

    try {
      const response = await dispatch<any>(GamesOperations.createGames(formData));
      return response;
    } catch (error: string | unknown) {
      console.log('Erro ao salvar jogos: ', error);
      return { status: 'error', message: 'Erro ao salvar o Jogo' };
    }
  };

  const handleUpdate = async (data: any): Promise<ResponseProps> => {
    const formData = new FormData();
    formData.append('id', data.id);
    formData.append('nome', data.nome);
    formData.append('nivel_id', data.nivel_id);
    formData.append('url', data.url);
    formData.append('imagem', data.imagem);

    try {
      const response = await dispatch<any>(GamesOperations.updateGame(formData));
      return response;
    } catch (error: string | unknown) {
      console.log('Erro ao salvar jogos: ', error);
      return { status: 'error', message: 'Erro ao salvar o Jogo' };
    }
  };

  const handleDelete = async (id: number): Promise<boolean> => {
    try {
      await dispatch<any>(GamesOperations.deleteGame(id));
      return true;
    } catch (error: string | unknown) {
      console.log('Erro deletando jogo: ', error);
      return false;
    }
  }

  if (HasError) {
    return (
      <React.Fragment>
        <Toast message={message} open={open} setclose={setOpen} severity="error" />
        <Failure message='Erro ao buscar jogos' onClick={getGames} />
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <AccountMenu />

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'left', justifyContent: 'flex-start' }}>
        <Box sx={{ width: "95%", margin: 'auto', padding: 2 }}>
          <Typography
            variant="h5"
            sx={{ color: "#000", fontWeight: "bold", marginTop: 2, marginBottom: 2 }}>
            Jogos
          </Typography>
          
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              marginBottom: 3,
            }}>
            <SearchField
              width={270}
              placeHolder="Buscar por nome, nível"
              data={Data}
              setSearch={setFilteredData}
              columnsToSearch={['nome', 'nivel']}
            />
          </Box>
          
          {IsLoading
            ? <SkeletonGrid />
            : <CrudJogos
                data={filteredData}
                onSave={handleSave}
                onUpdate={handleUpdate}
                onDelete={handleDelete}
              />
          }
        </Box>
      </Box>
    </React.Fragment>
  );
}